import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from './types';
import {
  fetchPasscodeLists,
  fetchPasscodeListMembers,
  fetchPasscodeListMemberCount,
  searchPasscodeListMembers,
  deletePasscodeList,
  setShowAddPasscodeListModal,
  fetchPaidLists,
  fetchGlobalCurrencies,
  fetchPaidListMembers,
  searchPaidListMembers,
  addPaidListMember,
  setAllProfilesUsers,
  setAllProfilesWatchtime,
  setAllProfilesAvgRating,
  setAllProfilesTotal,
  setAllProfilesLoading,
  setAllProfilesPage,
  setAllProfilesSearch,
  resetAllProfiles,
  setAllProfilesSort,
  setAllProfilesPageSize,
  setAllAttendeesLoading,
  setAllAttendeesUsers,
  setAllAttendeesTotal,
  setAllAttendeesPage,
  setAllAttendeesPageSize,
  setAllAttendeesSearch,
  setAllAttendeesSort,
  setAllAttendeesFields,
  setAllAttendeesStatus,
  setAllAttendeesRegistrationFilter,
  resetAllAttendees,
  fetchAllAttendees,
} from './reducers/index';

export const reducers = (create: ReducerCreators<AudiencesState>) => ({
  fetchPasscodeLists: fetchPasscodeLists(create),
  fetchPasscodeListMembers: fetchPasscodeListMembers(create),
  fetchPasscodeListMemberCount: fetchPasscodeListMemberCount(create),
  searchPasscodeListMembers: searchPasscodeListMembers(create),
  deletePasscodeList: deletePasscodeList(create),
  setShowAddPasscodeListModal: setShowAddPasscodeListModal(create),
  fetchPaidLists: fetchPaidLists(create),
  fetchGlobalCurrencies: fetchGlobalCurrencies(create),
  fetchPaidListMembers: fetchPaidListMembers(create),
  searchPaidListMembers: searchPaidListMembers(create),
  addPaidListMember: addPaidListMember(create),
  setAllProfilesUsers: setAllProfilesUsers(create),
  setAllProfilesWatchtime: setAllProfilesWatchtime(create),
  setAllProfilesAvgRating: setAllProfilesAvgRating(create),
  setAllProfilesTotal: setAllProfilesTotal(create),
  setAllProfilesLoading: setAllProfilesLoading(create),
  setAllProfilesPage: setAllProfilesPage(create),
  setAllProfilesSearch: setAllProfilesSearch(create),
  resetAllProfiles: resetAllProfiles(create),
  setAllProfilesSort: setAllProfilesSort(create),
  setAllProfilesPageSize: setAllProfilesPageSize(create),
  setAllAttendeesLoading: setAllAttendeesLoading(create),
  setAllAttendeesUsers: setAllAttendeesUsers(create),
  setAllAttendeesTotal: setAllAttendeesTotal(create),
  setAllAttendeesPage: setAllAttendeesPage(create),
  setAllAttendeesPageSize: setAllAttendeesPageSize(create),
  setAllAttendeesSearch: setAllAttendeesSearch(create),
  setAllAttendeesSort: setAllAttendeesSort(create),
  setAllAttendeesFields: setAllAttendeesFields(create),
  setAllAttendeesStatus: setAllAttendeesStatus(create),
  setAllAttendeesRegistrationFilter: setAllAttendeesRegistrationFilter(create),
  resetAllAttendees: resetAllAttendees(create),
  fetchAllAttendees: fetchAllAttendees(create),
});
